import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    tableInfoChip: {
      marginLeft: theme.spacing(2),
      background: colors.defaultGrey
    }
  });
});
